import { useEffect, useRef } from "react";
import { trapFocus } from "../../helpers";
import PropTypes from "prop-types";
import style from "./styles";
import PremierInfoMessage from "./PremierInfoMessage/index.jsx";
import PremierSelectorTitle from "./PremierSelectorTitle";
import PremierCountryOption from "./PremierCountryOption/index.jsx";
import CloseSVG from "../../../../../assets/premier-landing-page/img/svg/closeButton.svg";

const PremierSelectorOptions = ({
  assetsUrl,
  isVisible,
  countriesData,
  selectedCountry,
  setCountry,
  closeCountrySelector,
  premierCountrySelector,
  returnFocus,
}) => {
  const modalRef = useRef();
  const escapeModal = (e) =>
    e.key === "Escape" && closeCountrySelector(returnFocus);

  useEffect(() => {
    isVisible && trapFocus(modalRef.current);
  });

  if (isVisible) {
    return (
      <div
        className="PremierSelectorContainer"
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-label="Select Your Country"
        onKeyDown={(e) => escapeModal(e)}
      >
        <div
          className={style.PremierSelectorOptionsOverlay}
          onClick={() => closeCountrySelector(returnFocus)}
        ></div>

        <div className={style.PremierSelectorOptions}>
          <fieldset>
            <PremierSelectorTitle
              assetsUrl={assetsUrl}
              premierTitle={premierCountrySelector.title}
              closeCountrySelector={() => closeCountrySelector(returnFocus)}
              tabindex={countriesData.length}
            />
            <button
              className={style.close}
              aria-label="Close country selector (ESC)"
              onClick={() => closeCountrySelector(returnFocus)}
              autoFocus={true}
            >
              <CloseSVG alt="Close (ESC)" />
            </button>
            <ul className={style.PremierCountries}>
              {countriesData.map((country, i) => (
                <PremierCountryOption
                  key={i}
                  tabindex={i}
                  assetsUrl={assetsUrl}
                  selectedCountry={selectedCountry}
                  countryData={country}
                  countriesData={countriesData}
                  setCountry={setCountry}
                  premierAvailableText={premierCountrySelector.premierAvailable}
                />
              ))}
              <PremierInfoMessage
                premierCountrySelector={premierCountrySelector}
              />
            </ul>
          </fieldset>
        </div>
      </div>
    );
  }

  return null;
};

PremierSelectorOptions.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  countriesData: PropTypes.array.isRequired,
  selectedCountry: PropTypes.string.isRequired,
  setCountry: PropTypes.func.isRequired,
  closeCountrySelector: PropTypes.func.isRequired,
  premierCountrySelector: PropTypes.shape({
    title: PropTypes.string.isRequired,
    premierAvailable: PropTypes.string,
  }),
  returnFocus: PropTypes.func,
  assetsUrl: PropTypes.string.isRequired,
};

export default PremierSelectorOptions;
